import { getField, updateField } from "vuex-map-fields";

const initialState = () => ({
  drawer: false,
  darkMode: false,
  enableDarkMode: false,
});

export const state = initialState();

export const getters = {
  getField,
  isInDarkMode(state) {
    return state.darkMode;
  },
};

export const actions = {
  raiseErrorMessage({ state, commit }, msg) {
    commit("updateField", { path: "messageSnackbarErro", value: msg });
    commit("updateField", { path: "snackbarErro", value: true });
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
